import { useEffect, useRef } from 'react'
import { useSearchParams } from 'react-router-dom'

/**
 * "+"-menuen i topbjælken (components/CreateMenu.tsx) åbner siden med `?ny=<hvad>`, og siden åbner selv sin
 * formular. Så findes hver formular stadig kun ét sted - menuen er bare en genvej til den.
 */
export type CreateKind = 'sag' | 'servicesag' | 'kunde' | 'enhed' | 'opslag' | 'begivenhed' | 'opgave' | 'naerved' | 'kvittering' | 'ide' | 'afstemning' | 'ros' | 'salg' | 'tip' | 'bil' | 'skade' | 'maaltid' | 'moede' | 'mus' | 'laerling'

/** Hvad der er bedt om at oprette - uden at rydde det. Til en side, der først skal skifte fane. */
export function useRequestedCreate(): CreateKind | null {
  const [params] = useSearchParams()
  return params.get('ny') as CreateKind | null
}

/**
 * Kalder `onRequest`, når siden er åbnet fra "+"-menuen med en af `kinds` - også når man allerede står på siden
 * og vælger igen. Parameteren fjernes bagefter, så formularen ikke åbner igen ved en genindlæsning.
 */
export function useCreateRequest(kinds: CreateKind[], onRequest: (kind: CreateKind) => void) {
  const [params, setParams] = useSearchParams()
  const requested = params.get('ny') as CreateKind | null

  // Den nyeste funktion, uden at den skal med i effektens afhængigheder.
  const handler = useRef(onRequest)
  handler.current = onRequest

  useEffect(() => {
    if (!requested || !kinds.includes(requested)) return

    handler.current(requested)
    window.scrollTo({ top: 0 })

    const next = new URLSearchParams(params)
    next.delete('ny')
    setParams(next, { replace: true })
    // kinds er en fast liste på hver side.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requested])
}
